import _ from 'lodash'
import papa from 'papaparse'

const csvParser = {}

csvParser.parseLocalFile = function (localFile) {
  const results = papa.parse(localFile, { header: true, skipEmptyLines: true })
  console.log(results)
  const mapped = _.map(results.data, _.partialRight(_.pick, ['name', 'email', 'phone']))
  return mapped
}

csvParser.parseLocalFileImporter = function (localFile) {
  const results = papa.parse(localFile, { header: true, skipEmptyLines: true })
  return results
}

csvParser.unparseArray = function (array) {
  return papa.unparse(array, { delimiter: ',' })
}

csvParser.downloadFormatCsv = function () {
  const blob = new Blob([csvParser.unparseArray([{ name: '', email: '', phone: '' }])], { type: 'text/csv' })
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = 'format.csv'
  a.click()
}

export default csvParser
